import { gql } from '@apollo/client';

/**
 * GraphQL mutation for classifying content using blob URLs
 * Uses the existing classifyContent mutation with blob URLs instead of direct file uploads
 */
export const CLASSIFY_WITH_BLOB_URL = gql`
  mutation ClassifyWithBlobUrl($input: ClassifyContentInput!) {
    classifyContent(input: $input) {
      text
      elapsed
      contentType
      classificationType
      confidenceScore
      explanation
      contentUrl
      labels {
        severity
        label_num_map
        label_name
        label_short_name
        label_id
        confidence
        score
        scope {
          global
          community_groups
          communities
        }
        content_type
        metadata {
          label_status
          policy
          last_modified_at
        }
      }
      language
      languageDetected
      timestamp
      categories
      policies {
        id
        type
        created_by
        created_at
        last_modified_by
        last_modified_at
        community_id
        is_enabled
        name
        description
        labels {
          label_id
          severity
        }
      }
      non_triggered_policies {
        id
        type
        created_by
        created_at
        last_modified_by
        last_modified_at
        community_id
        is_enabled
        name
        description
        labels {
          label_id
          severity
        }
      }
    }
  }
`;

/**
 * @deprecated Use CLASSIFY_WITH_BLOB_URL instead
 * Legacy mutation for backward compatibility
 */
export const CLASSIFY_WITH_UPLOAD = CLASSIFY_WITH_BLOB_URL;
